import { SelectC, TextFieldC } from 'components'
import { useEffect, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'

type Props = {
  configuration: any
  name?: string
  loading?: boolean
  disabled?: boolean
}

export const LengthField = (props: Props) => {
  const {
    configuration,
    name = 'lengthField',
    loading = false,
    disabled
  } = props
  const { watch, setError, clearErrors } = useFormContext()

  const dataType = configuration?.dataType

  const initRange = configuration?.initRange
  const endRange = configuration?.endRange

  // console.log({ initRange, endRange })

  const currentField = watch(name)

  useEffect(() => {
    if (dataType !== 'N' || configuration?.contentType !== 'F') return
    if (initRange == null || endRange == null) return

    if (!currentField) {
      clearErrors(name)
      return
    }

    if (Number(currentField) < initRange || Number(currentField) > endRange) {
      setError(name, {
        message: `deve estar dentro da faixa de valores (${initRange} - ${endRange})`
      })
    } else {
      clearErrors(name)
    }
  }, [
    name,
    setError,
    clearErrors,
    initRange,
    endRange,
    currentField,
    dataType,
    configuration?.contentType
  ])

  const getLabel = useMemo(() => {
    let label = configuration?.name

    if (initRange != null && endRange != null)
      label += ` (${initRange} - ${endRange})`

    return label || 'Comp.'
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initRange, endRange, configuration, currentField])

  if (dataType === 'N' && configuration?.contentType !== 'P')
    return (
      <TextFieldC
        name={name}
        label={getLabel}
        disabled={disabled}
        loading={loading}
        normalize={(text) => {
          if (dataType === 'N')
            return text.replace(/\D/g, '').replace(/(\d{1,2})$/, '.$1')

          return text
        }}
      />
    )

  return (
    <SelectC
      name={name}
      label={getLabel}
      disabled={disabled}
      options={configuration?.contents || []}
      loading={loading}
      getOptionLabel={(option: any) =>
        option?.description?.trim() || option?.content?.trim()
      }
    />
  )
}
